import type { MouseEvent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { sourceHref } from '../lib/knowledge';
import type { KnowledgeSource } from '../lib/types';

// Who contributed something, linking to their page where they have one: a connected
// source or a document. A person is named as plain text.
export default function SourceLink({ source, className, onClick, children }: {
    source: KnowledgeSource;
    className?: string;
    onClick?: (e: MouseEvent) => void;
    children?: ReactNode;
}) {
    const href = sourceHref(source);
    const label = children ?? source.name ?? '—';
    if (!href) return <span className="text-graphite">{label}</span>;
    return <Link to={href} onClick={onClick} className={className ?? 'text-brand hover:underline'}>{label}</Link>;
}
